import { useContentful } from './useContentful';

import type { RichContentProps } from '@insify/funnel-components';

export const useContent = (): (ContentPnc & { isLoading: boolean }) | undefined => {
  const { data: contentfulData, isLoading } = useContentful<{ default: { items: [ContentPnc] } }>(
    'shop-content',
    query,
  );
  return contentfulData && { ...contentfulData['default'].items[0], isLoading };
};

export const query = `
query ($preview: Boolean, $locale: String) {
  default: frPncConfigCollection(where: {id: "default"}, preview: $preview, limit: 1, locale: $locale) {
    items {
      quoteWizardCompany {
        ...wizardPageContent
      }
      quoteWizardCompanyDetails {
        ...wizardPageContent
      }
      quoteWizardActivity {
        ...wizardPageContent
      }
      quoteWizardAdditionalQuestions {
        ...wizardPageContent
      }
      quoteWizardHeadcount {
        ...wizardPageContent
      }
      quoteWizardRevenue {
        ...wizardPageContent
      }
      quoteWizardDiscountQuestions {
        ...wizardPageContent
      }
      highcare {
        ...wizardPageContent
      }
      hardDecline {
        ...wizardPageContent
      }
      callbackRequested {
        ...wizardPageContent
      }
      coverageHeader {
        ...wizardPageContent
      }
      coverageProperty {
        ...wizardPageContent
      }
      coverageDeductible {
        ...wizardPageContent
      }
      coverageReceipt {
        ...wizardPageContent
      }
      representative {
        ...wizardPageContent
      }
      pastClaimsConfirm {
        ...wizardPageContent
      }
      pastClaimsThreshold {
        ...wizardPageContent
      }
      pastClaimsOverview {
        ...wizardPageContent
      }
      pastClaimsForm {
        ...wizardPageContent
      }
      pastInsurances {
        ...wizardPageContent
      }
      exclusions {
        ...wizardPageContent
      }
      propertyParams {
        ...wizardPageContent
      }
      checkoutCompany {
        ...wizardPageContent
      }
      checkoutImportantInformation {
        ...wizardPageContent
      }
      checkoutPayment {
        ...wizardPageContent
      }
      checkoutStartDate {
        ...wizardPageContent
      }
      confirmation {
        ...wizardPageContent
      }
      alreadyApplied {
        ...wizardPageContent
      }
    }
  }
}

fragment wizardPageContent on ComponentShopWizardContentBlock {
  content {
    json
  }
}`;

export type RichContent = RichContentProps['content'];

export type ContentPnc = {
  quoteWizardCompany: RichContent;
  quoteWizardCompanyDetails: RichContent;
  quoteWizardActivity: RichContent;
  quoteWizardAdditionalQuestions: RichContent;
  quoteWizardHeadcount: RichContent;
  quoteWizardRevenue: RichContent;
  quoteWizardDiscountQuestions: RichContent;
  highcare: RichContent;
  hardDecline: RichContent;
  callbackRequested: RichContent;
  coverageHeader: RichContent;
  coverageDeductible: RichContent;
  coverageProperty: RichContent;
  coverageReceipt: RichContent;
  representative: RichContent;
  pastClaimsConfirm: RichContent;
  pastClaimsThreshold: RichContent;
  pastClaimsOverview: RichContent;
  pastClaimsForm: RichContent;
  pastInsurances: RichContent;
  exclusions: RichContent;
  propertyParams: RichContent;
  checkoutCompany: RichContent;
  checkoutImportantInformation: RichContent;
  checkoutPayment: RichContent;
  checkoutStartDate: RichContent;
  confirmation: RichContent;
  alreadyApplied: RichContent;
};
